<template>
  <div class="appBody bg-white" style="height: auto" v-if="currentAdvSub">
    <little-header></little-header>
    <van-overlay :show="isShowCC" v-if="currentAdvSub.helpVideo">
      <div class="course-shaded position-relative"
           v-if="currentAdvSub.helpVideoResource && currentAdvSub.helpVideoResource.url && isShowCC">
        <div class="course-div">
          <iframe class="w-100 h-100" :src="'/static/videott/index1.html?vid='+currentAdvSub.helpVideoResource.url"/>
        </div>
        <img class="closeCC-btn position-absolute" @click="closeVideo"
             src="/static/img/pro/close.png">
      </div>
    </van-overlay>

    <adv-banner :currentAdvSub=currentAdvSub type="detail" :pState=pState :finishedRate="rate"
                @showCC="getShowCC"></adv-banner>
<!--    <div class="shareImg position-fixed cursor-pointer">-->
<!--      <img @click="onShare" src="/static/img/pro/share.png" alt="" class="">-->

<!--    </div>-->

    <div class="pro-nav justify-content-center align-items-center" v-if="scrollTag">
      <div class="w-100 d-flex justify-content-around align-items-center">
        <a class="pro-nav-a p-home-a" href="#">项目</a>
        <a class="pro-nav-a p-story-a" v-if="storyContent" :class="{active: navClass==='p-story'}" href="#p-story-1">详情</a>
        <a class="pro-nav-a p-ke-a" v-if="currentAdvSub.courseList && currentAdvSub.courseList.length > 0" :class="{active: navClass==='p-ke'}" href="#p-ke-1">课程</a>
        <a class="pro-nav-a p-kao-a"  v-if="currentAdvSub.assessmentDesc" :class="{active: navClass==='p-kao'}" href="#p-kao-1">考核</a>
        <a class="pro-nav-a p-zj-a" v-if="currentAdvSub.leaderList && currentAdvSub.leaderList.length>0"
           :class="{active: navClass==='p-zj'}" href="#p-zj-1">师资</a>
        <a class="pro-nav-a p-zz-a" v-if="currentAdvSub.hasCertificate && currentAdvSub.certificate" :class="{active: navClass==='p-zz'}" href="#p-zz-1">证书</a>
      </div>
    </div>
    <adv-story v-if="storyContent" :story="storyContent"></adv-story>

    <adv-course v-if="currentAdvSub.courseList && currentAdvSub.courseList.length > 0" :advSub=currentAdvSub></adv-course>
    <adv-kao v-if="currentAdvSub.assessmentDesc" :checkContent="currentAdvSub.assessmentDesc"></adv-kao>
    <adv-expert v-if="currentAdvSub.leaderList && currentAdvSub.leaderList.length > 0" :advSubLecturers=currentAdvSub.leaderList></adv-expert>
    <adv-zi-zhi v-if="currentAdvSub.hasCertificate && currentAdvSub.certificate" :zizhiObj="currentAdvSub"></adv-zi-zhi>
    <little-footer></little-footer>
    <!--<van-notice-bar class="p-zz notice bg-ee"-->
    <!--color="#eee">-->
    <!--<template #default>-->
    <!--<p class="color-base mb-0 text-center">-->
    <!--<span class="color-33">报名时间：</span>{{currentAdvSub.signUpStartTime|dateFormat('YYYY-MM-DD')}}&#45;&#45;{{currentAdvSub.signUpEndTime|dateFormat('YYYY-MM-DD')}}-->
    <!--</p>-->
    <!--</template>-->
    <!--</van-notice-bar>-->
  </div>
</template>
<script>
  import advBanner from '@/page/subject/components/advBanner'
  import advStory from '@/page/subject/components/advStory'
  import advCourse from '@/page/subject/components/advCourse'
  import advKao from '@/page/subject/components/advKao'
  import advExpert from '@/page/subject/components/advExpert'
  import advZiZhi from '@/page/subject/components/advZiZhi'
  import FootPrice from '@/page/subject/components/footPrice'
  import littleFooter from '@/page/lecturer/components/littleFooter';
  import LittleHeader from "@/components/littleHeader";

  import Vue from 'vue';
  import {NavBar} from 'vant';
  import {Tabbar, TabbarItem} from 'vant';
  import {Icon} from 'vant';
  import {NoticeBar} from 'vant';
  import {Overlay} from 'vant';
  import Cookies from "js-cookie";

  Vue.use(Overlay);
  Vue.use(NoticeBar);
  Vue.use(Icon);
  Vue.use(Tabbar);
  Vue.use(TabbarItem);
  Vue.use(NavBar);

  export default {
    name: "projectDetail",
    components: {
      advBanner,
      advStory,
      advCourse,
      advKao,
      advExpert,
      advZiZhi,
      FootPrice,
      LittleHeader,
      littleFooter
    },
    data() {
      return {
        active: 0,
        userState: '',
        scrollTag: false,
        navClass: '',
        advSubCourse: [],
        advSubLecturers: [],
        showShare: false,
        shareObj: {},
        projectId: '',
        currentAdvSub: {},
        price: 0,
        totalCoursePrice: 0,
        isShowCC: false,
        pState: 0,
        rate: 0,
        storyContent: '',
        currentUser: {},
        isManager: false
      }
    },
    mounted() {
      this.projectId = this.$route.params['id'];
      if (Cookies.get('u_info')) {
        this.currentUser = JSON.parse(Cookies.get('u_info'))
      } else {
        this.currentUser = {};
      }
      this.scrollFun();
      this.getRolePro();
    },
    methods: {
      getRolePro() {
        this.isManager = false;
        if(this.currentUser && this.currentUser.id) {
           for(let role of this.currentUser.authorities) {
             console.log(role.authority);
             if(role.authority==='ROLE_OPERATION'||role.authority==='ROLE_SYSTEM') {
               this.isManager = true;
               break;
             }
           }
        }
        if (this.isManager) {
          this.getProjectForCreator();
        } else {
          this.getProjectForLearner();
        }
      },
      getProjectForLearner() {
        this.$store.dispatch('getProjectForLearner', {id: this.projectId}).then((res) => {
          this.currentAdvSub = res;
          this.calcProject();
        })
      },
      getProjectForCreator() {
        this.$store.dispatch('getProjectForCreator', {id: this.projectId}).then((res) => {
          this.currentAdvSub = res;
          this.calcProject();
        })
      },
      calcProject() {
        if (this.currentAdvSub && this.currentAdvSub.id) {
          // 详情
          if(this.currentAdvSub.detail) {
            this.$store.dispatch('getContent', {content: this.currentAdvSub.detail}).then((res) => {
              this.storyContent = res;
            }, (error) => {
              this.storyContent = ''
            })
          }
          let currentDate = new Date().getTime();
          //计算开放时间是否结束
          let startTime = this.currentAdvSub.learningStartTime;
          let endTime = this.currentAdvSub.learningEndTime;
          if (currentDate >= startTime && currentDate <= endTime) {
            this.pState = 1;
          } else if (currentDate > endTime) {
            this.pState = 2;
          } else {
            this.pState = 0;
          }
          if (this.currentAdvSub.statInfo) {
            if (this.currentAdvSub.statInfo.signedUpCount && this.currentAdvSub.statInfo.signedUpCount !== 0 && this.currentAdvSub.statInfo.learnedCount && this.currentAdvSub.statInfo.learnedCount !== 0) {
              this.rate = (this.currentAdvSub.statInfo.learnedCount / this.currentAdvSub.statInfo.signedUpCount) * 100
            } else {
              this.rate = 0;
            }
          } else {
            this.rate = 0;
          }

        } else {
          this.isEnd = false;
          this.rate = 0;
        }

      },

      getShowCC(e) {
        this.isShowCC = e;
      },
      closeVideo() {
        this.isShowCC = false;
      },
      scrollFun() {
        let _this = this;
        let h11 = $('.pro-nav').height() + 10;
        $('.h11').css('top', -h11 + 'px');

        window.addEventListener('scroll', () => {
          let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
          if (top > $('.pro-banner').height() - 150) {
            _this.scrollTag = true;
          } else {
            _this.scrollTag = false
          }

          let stroyH = $('#p-story')[0]?$('#p-story')[0].offsetTop:0;
          let keH = $('#p-ke')[0]?$('#p-ke')[0].offsetTop:0;
          let kaoH = $('#p-kao')[0]?$('#p-kao')[0].offsetTop:0;
          let zjH = $('#p-zj')[0]?$('#p-zj')[0].offsetTop:0;
          let zzH = $('#p-zz')[0]?$('#p-zz')[0].offsetTop:0;

          if(zzH >0 && top >= zzH-100) {
            _this.navClass = 'p-zz';
          }else if(zjH >0 && top >= zjH-100) {
            _this.navClass = 'p-zj';
          }else if(kaoH >0 && top >= kaoH-100) {
            _this.navClass = 'p-kao';
          }else if(keH >0 && top >= keH-100) {
            _this.navClass = 'p-ke';
          }else if(stroyH>0 && top >= stroyH-100) {
            _this.navClass = 'p-story';
          }

        })
      },

      // onShare() {
      //   this.shareObj = this.currentAdvSub;
      //   this.shareObj.qrcodeUrl = window.location.href;
      //   this.shareObj.fromPageType = 'project';
      //   localStorage.setItem('share_obj', JSON.stringify(this.shareObj))
      //   this.$router.push('/share-poster');
      // },

    }
  }
</script>

<style>

</style>
